/*
 * @Description:
 * @Date: 2022-12-01 10:51:05
 */
import { terminalPayMgrParam } from '@/views/industry-terminal-pay/src/data-source/types';
import { ref } from 'vue';

export const state = {
  active: ref(1),
  tableRenderRef: null
};

export function dealParam(param) {
  return Object.entries({
    type: state.active.value,
    payDtStart: param.dateArr?.[0],
    payDtEnd: param.dateArr?.[1],
    ...param
  }).reduce((pre, [key, value]) => {
    if (value) {
      pre[key] = value;
    }
    return pre;
  }, {} as terminalPayMgrParam);
}
